import React from 'react';
import { arrayOf, number, shape, string } from 'prop-types';
import { Histogram } from '@thd-olt-component-react/histogram';
import { Typography } from '@one-thd/sui-atomic-components';

export const RatingDetailed = ({
  averageOverallRating,
  notRecommendedCount,
  ratingDistribution,
  recommendedCount,
  totalReviewCount
}) => {

  const formatHistogramData = (data) => {
    return data.map((element) => {
      return {
        ratingValue: element.RatingValue,
        count: element.Count
      };
    });
  };

  const getRecommendationPercentage = (recommended, notRecommended) => {
    const recommendedInt = parseInt(recommended, 10);
    const notRecommendedInt = parseInt(notRecommended, 10);
    return String(Math.round((recommendedInt / (recommendedInt + notRecommendedInt)) * 100));
  };

  if (!(averageOverallRating && notRecommendedCount && ratingDistribution && recommendedCount && totalReviewCount)) {
    return null;
  }

  return (
    <>
      <div className="sui-flex sui-p-2">
        <span className="sui-w-1/2">
          <Typography variant="h3">
            {averageOverallRating}
          </Typography>
          <div>
            out of {totalReviewCount} reviews
          </div>
        </span>

        <span className="sui-w-1/2">
          <Typography variant="h3">
            {getRecommendationPercentage(
              recommendedCount, notRecommendedCount
            )}%
          </Typography>
          recommend this store
        </span>
      </div>
      <div className="sui-p-2">
        <Histogram
          ratings={formatHistogramData(ratingDistribution)}
          totalReviews={totalReviewCount}
        />
      </div>
    </>
  );
};

RatingDetailed.propTypes = {
  notRecommendedCount: number.isRequired,
  recommendedCount: number.isRequired,
  averageOverallRating: string.isRequired,
  ratingDistribution: arrayOf(shape({
    RatingValue: number,
    Count: number
  })).isRequired,
  totalReviewCount: number.isRequired
};

RatingDetailed.displayName = 'RatingDetailed';
